export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/config.js
// module id = 1488
// module chunks = 2